import React from 'react';
import { MoveRight, MoveDown } from 'lucide-react';
import { CircleFigure } from './primitives';
import { MULTIPLIER_IMG } from '../media';
const items = [{
  label: 'A new material',
  text: <>
        Stronger, lighter,
        <br data-id="element-147" data-mp="1mrwcuh5iu4uo" />
        more sustainable
      </>,
  img: MULTIPLIER_IMG.material,
  alt: 'Woven natural material texture'
}, {
  label: 'A biological sensor',
  text: 'Inspired by living systems',
  img: MULTIPLIER_IMG.sensor,
  alt: 'Backlit leaf vein network resembling a biological sensor'
}, {
  label: 'An autonomous machine',
  text: 'Built for regeneration',
  img: MULTIPLIER_IMG.machine,
  alt: 'Agricultural drone flying over a green field'
}];
const solution = {
  label: 'A solution that didn’t exist before.',
  img: MULTIPLIER_IMG.solution,
  alt: 'Green field rows leading toward mountains'
};
function Cell({
  label,
  text,
  img,
  alt,
  size
}: {
  label: string;
  text?: React.ReactNode;
  img: string;
  alt: string;
  size: 'sm' | 'md' | 'lg';
}) {
  return <div className="min-w-0" data-id="element-148" data-mp="vz6copy9b7qu">
      {/* Fixed label and caption bands keep every circle on the same baseline,
          however many lines the copy runs to. */}
      <div className="mb-4 flex h-9 items-end justify-center sm:h-10" data-id="element-149" data-mp="r0lmljcpy4g4">
        <b className="block break-words text-center text-[9px] uppercase leading-tight tracking-[0.1em] sm:text-[11px] sm:tracking-[0.18em]" data-id="element-150" data-mp="m1sb1wgzsnil">
          {label}
        </b>
      </div>
      <CircleFigure src={img} alt={alt} size={size} data-id="element-151" data-mp="1ep4jl2qbiusw" />
      <p className="mt-3 min-h-[2.75rem] text-center text-body-sm leading-snug text-muted-foreground" data-id="element-152" data-mp="1eqfxhvdh9ixq">
        {text}
      </p>
    </div>;
}
export function MultiplierRow() {
  return <>
      {/* Phones: three across with plus signs, then an arrow down to the result. */}
      <div className="text-center lg:hidden" data-id="element-153" data-mp="22gthcylwsbh8">
        <div className="grid grid-cols-[1fr_auto_1fr_auto_1fr] items-start gap-1" data-id="element-154" data-mp="1xoifhq7lyfm1">
          <Cell {...items[0]} size="sm" data-id="element-155" data-mp="1xmp828p67rcz" />
          <span className="pt-[66px] text-xl leading-none" aria-hidden="true" data-id="element-156" data-mp="3rw46z38616ak">
            +
          </span>
          <Cell {...items[1]} size="sm" data-id="element-157" data-mp="3vwwjq6g8xtbl" />
          <span className="pt-[66px] text-xl leading-none" aria-hidden="true" data-id="element-158" data-mp="3vzsfbo4mg5wv">
            +
          </span>
          <Cell {...items[2]} size="sm" data-id="element-159" data-mp="3n5nublc65op9" />
        </div>
        <MoveDown className="mx-auto mt-8 text-accent" size={32} aria-hidden="true" data-id="element-160" data-mp="3n4cn1bjilyte" />
        <div className="mx-auto mt-8 max-w-44" data-id="element-161" data-mp="387bvb81bq3ux">
          <Cell {...solution} size="lg" data-id="element-162" data-mp="38apy2hdwgf2w" />
        </div>
      </div>

      {/* Desktop: one row. */}
      <div className="hidden grid-cols-[1fr_auto_1fr_auto_1fr_auto_1fr] items-start gap-2 text-center lg:grid" data-id="element-163" data-mp="3d53p67lj401r">
        <Cell {...items[0]} size="md" data-id="element-164" data-mp="346rwm013qs6o" />
        <span className="pt-[86px] text-4xl leading-none" aria-hidden="true" data-id="element-165" data-mp="347kyaml7erhy">
          +
        </span>
        <Cell {...items[1]} size="md" data-id="element-166" data-mp="xhn58wh9dqdt" />
        <span className="pt-[86px] text-4xl leading-none" aria-hidden="true" data-id="element-167" data-mp="xehi3ms6wykq">
          +
        </span>
        <Cell {...items[2]} size="md" data-id="element-168" data-mp="1cjd6muf0az06" />
        <MoveRight className="mt-[78px] text-accent" size={36} aria-hidden="true" data-id="element-169" data-mp="1ckeszv1h37x7" />
        <Cell {...solution} size="md" data-id="element-170" data-mp="17kseli9wrlmt" />
      </div>
    </>;
}